// authConfig.ts
import { Configuration, PublicClientApplication } from '@azure/msal-browser';

export const msalConfig: Configuration = {
    auth: {
        clientId: 'baf53fe0-22e3-4855-ba01-bd8774c38412',
        authority: 'https://login.microsoftonline.com/08455b90-5d90-4a89-937b-8c2322b2c786',
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ['OnlineMeetings.Read', 'User.Read', 'OnlineMeetingArtifact.Read.All'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
